module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.2408/img/screenshot-og.png"